
export const FILTER_CURRENT = 'current';
export const FILTER_APPLIED = 'applied';
export const FILTER_QUERY_MANDATORY = 'queryMandatory';
export const FILTER_DATE_NOW = 'now';
export const FILTER_DATE_COMING_WEEK = 'comingweek';
export const FILTER_DATE_NEXT_WEEK = 'nextweek';
export const FILTER_DATE_LAST_WEEK = 'lastweek';
